import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import Layout from '../../components/layout/layout.component'
import TableGrid from '../../components/table.grid/table.grid.component'
import {actions, selectors, user} from '../../state/modules'
import { useNavigate } from 'react-router-dom'
import ServerModal from '../../components/modal/modal.component'
import { defaultDataModal } from '../../components/modal/modal.utils'

function Location({
  locations,
  locationsLoading,
  setCurrentLocation,
  deleteLocation,
  currentLocationError,
  clearCurrentLocationError,
  currentUserAuth
}) {
  const pageName = 'Location'
  const navigate = useNavigate()
  const [modal, setModal] = useState({ ...defaultDataModal })
  const rolUser = currentUserAuth?.rol > -1 ? currentUserAuth.rol : 3

  useEffect(() => {
      if (rolUser != 0) {
          return navigate(`/`)
      }
  },[])

  const handleClickAddNew = () => {
    navigate(`/${pageName.toLowerCase()}/detail/null`)
  }
  const onEditHandler = row => {
    const currentLocation = locations.data.find(source => source.id === row.id)
    if (currentLocation) {
      setCurrentLocation(currentLocation)
      return navigate(`/${pageName.toLowerCase()}/detail/${row.rowId}`)
    }
    return alert(`${row.name} and ${row.id} don't exist`)
  }

  const onDeleteHandler = row => {
    setModal({
      open: true,
      title: 'Notice!',
      description: `"${row.col1} #${row.rowId} " will be delete`,
      type: 'delete',
      id: row.rowId,
    })
  }

  const handleCloseModal = () => {
    setModal({ ...defaultDataModal, open: false })
  }

  const handleAccept = id => {
    if (modal.type === 'delete') {
      deleteLocation(id)
    } else if (modal.type === 'error') {
      setModal({ ...defaultDataModal, open: false })
      clearCurrentLocationError()
    }
  }

  useEffect(() => {
    if (currentLocationError.name) {
      setModal({
        open: true,
        title: 'Error!',
        description: `${currentLocationError.error}`,
        type: 'error',
        id: null,
      })
    }
  }, [currentLocationError.name])

  return (
    <Layout>
      <TableGrid
        name={pageName}
        rows={locations.body}
        columns={locations.header}
        loading={locationsLoading}
        limit={50}
        total={50 * locations.total}
        onEdit={onEditHandler}
        onDelete={onDeleteHandler}
        onClickAddNew={handleClickAddNew}
        paginationMode='client'
        rolUser={rolUser}
      />
      <ServerModal
        isOpen={modal.open}
        title={modal.title}
        description={modal.description}
        id={modal.id}
        showBtns
        onAccept={handleAccept}
        onClose={handleCloseModal}
      />
    </Layout>
  )
}

const mapStateToProps = createStructuredSelector({
  locations: selectors.location.selectLocationList,
  locationsLoading: selectors.location.selectLocationLoading,
  currentLocationError: selectors.location.selectLocationCurrentError,
  currentUserAuth: user.selectors.selectCurrentUserAuth,
})

const mapDispatchToProps = dispatch => ({
  setCurrentLocation: location =>
    dispatch(actions.location.setCurrentLocation(location)),
  deleteLocation: id => dispatch(actions.location.deleteLocation(id)),
  clearCurrentLocationError: () =>
    dispatch(actions.location.clearCurrentError()),
})

export default connect(mapStateToProps, mapDispatchToProps)(Location)
